<template>
  <div id="app">
    <nav-bar class="do-not-print" v-if="!layout.hideNav"></nav-bar>
    <router-view @modifyLayout="modifyLayout"></router-view>
    <site-footer class="do-not-print" :minimal="layout.minimalFooter" v-if="!layout.hideFooter"></site-footer>
  </div>
</template>

<script>
import navigation from './components/nav/nav'
import siteFooter from './components/footer/footer'
import metaContent from './data/meta.json'
import meta from './mixins/meta.js'
import services from './services/services.js'
import Cookies from 'js-cookie'

export default {
  name: 'app',
  mixins: [meta],
  data () {
    return {
      layout: {}
    }
  },
  components: {
    'nav-bar': navigation,
    'site-footer': siteFooter
  },
  created: function () {
    this.$router.beforeEach((to, from, next) => {
      this.modifyLayout({})
      next()
    })
    this.doMeta()
    this.$router.afterEach((to, from) => {
      this.doMeta()
    })
    this.$http.interceptors.request.use(function (config) {
      let xsrf = Cookies.get('XSRF-TOKEN')
      if (xsrf) {
        config.headers['RB-CSRF-Token'] = xsrf
      }
      let formEncoded = config.headers['Content-Type'] &&
        config.headers['Content-Type'].indexOf('application/x-www-form-urlencoded') > -1
      let notFormData = !(config.data instanceof FormData)
      if (notFormData && formEncoded) {
        config.data = services.urlEncodeData(config.data)
      }
      return config
    })
    this.$store.$http = this.$http
    this.$store.ENV = this.ENV
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch('prepareUserData')
    }
    this.checkMKT()
  },
  methods: {
    checkMKT: function () {
      if (Cookies.get('rb_mkt') || Cookies.get('TB_SESSION')) return
      let query = location.search
      if (query) {
        let params = Object.fromEntries(new URLSearchParams(query))
        if (params.cjevent) {
          params.trans_id = params.cjevent
        }
        Cookies.set('rb_mkt', JSON.stringify(params), {expires: 60 * 60 * 24 * 1000})
      }
    },
    doMeta: function () {
      if (metaContent[this.$route.name]) {
        this.applyMeta(metaContent[this.$route.name])
      }
    },
    modifyLayout: function (modifier) {
      this.layout = {
        hideFooter: modifier.hideFooter || false,
        hideNav: modifier.hideNav || false,
        bgColor: modifier.bgColor || '',
        minimalNavigation: modifier.minimalNavigation || false
      }
    }
  }
}

</script>
<style src="./styles/main.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/App.vue